/* Gets URL value of option and goes to tag page */

function exploreSelect(selector) {
  const element = document.querySelector(selector);

  if (!element) return;

  element.addEventListener("change", function (e) {
    const url = e.target.value;
    if (url) {
      window.location.href = url;
    }
  });
}

exploreSelect("#tags");